import { SetupForm } from "@/components/setup/Setup.form.tsx";
import { useNavigate } from "react-router-dom";
import { useStore } from "@/stores/useStore.ts";
import { useEffect } from "react";

export const CreateOrLinkPage = () => {
  const navigate = useNavigate();
  const allowedTenants = useStore((s) => s.allowedTenants);

  useEffect(() => {
    if (allowedTenants && allowedTenants.length > 0) {
      navigate(`/app/${allowedTenants[0].id}`);
    }
  }, [allowedTenants]);

  return (
    <div className="flex flex-col max-w-screen-md p-4 mx-auto">
      <h1 className="text-2xl font-bold">Setup Your Account</h1>
      <div>
        <p>
          Welcome! Your account is not connected to any companies. Let's get you
          routed correctly!
        </p>
        <SetupForm />
      </div>
    </div>
  );
};
